import * as React from "react";

import { PageAlternate, BreadCrumbProps } from "../subs/PageAlternate";
import { PageSection } from "../subs/PageSection";

import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Stack, Typography } from "@mui/material";
import { useLocation, useParams } from "react-router";
import { UserContext } from "../UserProvider";
import { AlertProps } from '@mui/material/Alert';

import ImportExportIcon from '@mui/icons-material/ImportExport';
import SaveIcon from '@mui/icons-material/Save';

import { WorkshopProduct, getWorkshopProducts, getSingleWorkshopProduct, updateWorkshopProduct } from "../types/WorkshopProducts";
import { Product, getProducts } from "../types/Product";
import { httpGet , httpPost } from "../Web";
import { ProductInterface } from "../types/ProductInterface";
import { Interface, enumerateInterfaces } from "../types/Interface";
import { InterfaceAccordion, InterfacesToProperties } from "./WSTesting/InterfaceAccordian";
import { InputCompletionChip } from "./WSTesting/InputCompletionChip";
import { ProductTreeView } from "./WSTesting/ProductTreeView";
import { TestingInfo } from "./WSTesting/TestingInfo";
import { WorkshopInterface } from "../types/WorkshopInterface";
import { WorkshopTestCase, WorkshopTestCaseMap, getWSProductTestcases } from "../types/WorkshopTestCases";
import { insertresultheaders } from "../types/WorkshopResult";
import { TestCombination, TestComboSupportVal, getTestComboSupport, getTestCombinationList } from '../types/TestCombinations';
import { WorkshopProductCombination, WSProdConfigCounters, GetEmptyWSPTC, getWSProductCombinations, getProductCombinations, getWSProdConfigCounters, updateProdTestCombination } from '../types/WorkshopProductCombination';
import { TestCase, getTestCases } from '../types/TestCase';
import { getWorkshopUsers } from '../types/WorkshopUser';
import { WorkshopProductForm } from "./WSTesting/WorkshopProductForm";
import { ButtonLink } from "../subs/ButtonLink";
import { isGlobalAdmin } from '../types/User';
import { ImportWorkshopProductNRModal } from "../modals/ImportWorkshopProductNRModal";

import VisibilityIcon from '@mui/icons-material/Visibility';

import { getCompanyWpID } from "../types/Company";
import { WSTestCasesConfig } from "./WSTesting/WSTestCasesConfig";

import { getWorkshopProductInterfaces } from "../types/WorkshopProductInterface";
import { getWorkshopInterfaces } from "../types/Workshop";
import { copyArrayWithIndexChanged } from "../Utils";
import { useSnackbar } from '../../contexts/SnackBarContext';

export interface WSProdFormProps {
    workshopProduct: WorkshopProduct,
    product: Product,
    productInterfaces: ProductInterface[],
    workshopTestcases: WorkshopTestCase[],
    testCases: Map<number, TestCase[]> | undefined,
    interfaces: Interface[],
    workshopInterfaces: WorkshopInterface[],
    selectedTreeType: string,
    disabled?: boolean,
    wpSubmitHandler: (workshopProduct: WorkshopProduct, wspCombination: WorkshopProductCombination) => void,
    wpIfaceSubmitHandler: (wpIface: ProductInterface[]) => void
}

const composePageHeading = (product: Product, workshopProduct: WorkshopProduct) => {
    if (!product || !workshopProduct) return "Product Selection Error";
    return `${product.name} ${workshopProduct.productVersion ?? ""}`;
}

const CancelSaveButtons = () =>
    <Stack direction='row' columnGap={20}>
        <Button form='productForm' type='submit' startIcon={<SaveIcon/>}>Save</Button></Stack>
        
const ImportPanel = ({ workshopProduct, refreshWorkshopProductHandler }:
    { workshopProduct: WorkshopProduct, refreshWorkshopProductHandler: (workshopProduct: WorkshopProduct) => void }) => {

    //  const location = useLocation();
    const [importModalOpenState, setImportModalOpenState] = React.useState<boolean>(false);
    const [givenProductID, setGivenProductID] = React.useState<number>(0);

    return <>
        <ImportWorkshopProductNRModal workshopId={workshopProduct.workshopId} currentWorkshopProductId={workshopProduct.id} givenProductID={givenProductID}
            refreshWorkshopProductHandler={refreshWorkshopProductHandler} openState={importModalOpenState} setOpenState={setImportModalOpenState} />

        <PageSection heading='Import settings from another instance:'>
            <Button startIcon={<ImportExportIcon />} onClick={() => { setGivenProductID(workshopProduct.productId); setImportModalOpenState(true) }} >from previous Workshops</Button>
            <Button startIcon={<ImportExportIcon />} onClick={() => { setGivenProductID(0); setImportModalOpenState(true)}}>from another Product</Button>
        </PageSection></>

    /*return <>
        <PageSection heading='Import settings from another instance:'>
            <ButtonLink to={`/ImportPreviousWPInstance/${workshopProduct.workshopId}/${workshopProduct.id}/${workshopProduct.productId}`} state={{ background: location }} startIcon={<ImportExportIcon />}>from previous Workshops</ButtonLink>
            <ButtonLink to={`/ImportPreviousWPInstance/${workshopProduct.workshopId}/${workshopProduct.id}/${0}`} state={{ background: location }} startIcon={<ImportExportIcon />}>from another Product</ButtonLink>
        </PageSection></>*/
}

const ClientScreen = ({ selectedTreeType, isGlobalAdminUser, workshopProduct, product, productInterfaces, interfaces, workshopInterfaces,
    disabled, workshopTestcases, wsProdCombination, testCombinations, wsProdCombinations,
    testCases, wpSubmitHandler, wptcUpdateHandler, refreshWorkshopProductHandler, wpIfaceSubmitHandler, wsTestCaseHandler }:
    WSProdFormProps & {
        isGlobalAdminUser: boolean,
        testCombinations?: TestCombination[],
        wsProdCombination: WorkshopProductCombination,
        wsProdCombinations?: WorkshopProductCombination[],
        wsTestCaseHandler: (wstc: WorkshopTestCase[]) => void,
        wptcUpdateHandler: (wspCombination: WorkshopProductCombination, wspCombinations: WorkshopProductCombination[]) => void,
        refreshWorkshopProductHandler: (workshopProduct: WorkshopProduct) => void
    }) => {
    const [wpFormComplete, setWpFormComplete] = React.useState(false);
    const [testCombination, settestCombination] = React.useState<TestCombination | undefined>(undefined);

    React.useEffect(() => {
        settestCombination(testCombinations ? testCombinations.find(tc => tc.id === wsProdCombination?.testCombinationId) : undefined);
    }, [testCombinations, wsProdCombination]);

    return <Stack rowGap={20}>
        <ImportPanel workshopProduct={workshopProduct} refreshWorkshopProductHandler={refreshWorkshopProductHandler} />
        <Accordion defaultExpanded={true}>
            <AccordionSummary>
                <Stack width={'100%'} direction={'row'} justifyContent={'space-between'}>
                    <Typography variant='bold'>{testCombination ? `${testCombination.combinationConsumer ?? 'Client'} information: ${testCombination.combinationName ?? ''}` :
                        'Client information'}</Typography>
                    {/* <Typography variant='bold'>{testCombinations ? `Selected Combination: ${testCombinations.find(tc => tc.id === wptc?.testCombinationId)?.combinationName ?? ''}` : ''}</Typography> */ }
                    <InputCompletionChip completed={wpFormComplete} />
                </Stack>
            </AccordionSummary>

            <AccordionDetails>
                <WorkshopProductForm workshopProduct={workshopProduct}
                    isGlobalAdminUser={isGlobalAdminUser}
                    testCombinations={testCombinations}
                    wsProdCombinations={wsProdCombinations}
                    product={product}
                    selectedTreeType={selectedTreeType}
                    wsProdCombination={wsProdCombination}
                    testCases={testCases}
                    wptcUpdateHandler={wptcUpdateHandler}
                    workshopTestcases={workshopTestcases}
                    productInterfaces={productInterfaces}
                    interfaces={interfaces}
                    workshopInterfaces={workshopInterfaces}
                    disabled={disabled}
                    wpSubmitHandler={wpSubmitHandler}
                    wpIfaceSubmitHandler={wpIfaceSubmitHandler}
                    completionFlagSetter={setWpFormComplete}
                    />
            </AccordionDetails>
        </Accordion>
        <CancelSaveButtons />
        <WSTestCasesConfig
            testCombination={testCombinations ? testCombinations.find(tc => tc.id === wsProdCombination?.testCombinationId) : undefined}
            product={product} workshopProduct={workshopProduct} interfaces={interfaces} productInterfaces={productInterfaces}
            wsProdCombination={wsProdCombination} workshopTestcases={workshopTestcases} testCases={testCases} wsTestCaseHandler={wsTestCaseHandler} />
    </Stack>
}
   
const ServerScreen = ({ selectedTreeType, isGlobalAdminUser, workshopProduct, product, productInterfaces, interfaces, workshopInterfaces, disabled,
    workshopTestcases, testCases, refreshWorkshopProductHandler, wsTestCaseHandler, wpSubmitHandler, wsProdCombination,
    testCombinations, wsProdCombinations, wptcUpdateHandler, interfacesProperties, wpIfaceSubmitHandler }:
    WSProdFormProps & {
        isGlobalAdminUser: boolean,
        testCombinations?: TestCombination[],
        wsProdCombination: WorkshopProductCombination,
        wsProdCombinations?: WorkshopProductCombination[],
        interfacesProperties: InterfacesToProperties[],
        wsTestCaseHandler: (wstc: WorkshopTestCase[]) => void,
        wptcUpdateHandler: (wspCombination: WorkshopProductCombination, wspCombinations: WorkshopProductCombination[]) => void,
        refreshWorkshopProductHandler: (workshopProduct: WorkshopProduct) => void
    }) => {
    const [wpFormComplete, setWpFormComplete] = React.useState(false);
    //  const [displayUnsupportedTestCases, setDisplayUnsupportedTestCases] = React.useState(false);

    const [testCombination, settestCombination] = React.useState<TestCombination | undefined>(undefined);

    React.useEffect(() => {
        settestCombination(testCombinations ? testCombinations.find(tc => tc.id === wsProdCombination?.testCombinationId) : undefined);
    }, [testCombinations, wsProdCombination]);

    return <Stack rowGap={20}>
        {/*displayUnsupportedTestCases ?*/}
        {<><ImportPanel workshopProduct={workshopProduct} refreshWorkshopProductHandler={refreshWorkshopProductHandler} />
                <Accordion defaultExpanded={true}>
                    <AccordionSummary>
                    <Stack width={'100%'} direction={'row'} justifyContent={'space-between'}>
                        <Typography variant='bold'>{testCombination ? `${testCombination.combinationProvider ?? 'Server'} information: ${testCombination.combinationName ?? ''}` :
                            'Server information'}</Typography>
                            {/*<Typography variant='bold'>{"Server information"}</Typography>*/}
                            <InputCompletionChip completed={wpFormComplete} />
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <WorkshopProductForm workshopProduct={workshopProduct}
                            isGlobalAdminUser={isGlobalAdminUser}
                            testCombinations={testCombinations}
                            wsProdCombinations={wsProdCombinations}
                            product={product}
                            wptcUpdateHandler={wptcUpdateHandler}
                            selectedTreeType={selectedTreeType}
                            wsProdCombination={wsProdCombination}
                            testCases={testCases}
                            workshopTestcases={workshopTestcases}
                            productInterfaces={productInterfaces}
                            interfaces={interfaces}
                            workshopInterfaces={workshopInterfaces}
                            disabled={disabled}
                            wpSubmitHandler={wpSubmitHandler}
                            wpIfaceSubmitHandler={wpIfaceSubmitHandler}
                            completionFlagSetter={setWpFormComplete}
                            />
                    </AccordionDetails>
                </Accordion>
                <CancelSaveButtons />
                <Typography variant='h5'>{"Specific Server characteristics or optional features."}</Typography>

                <InterfaceAccordion interfaceToProperties={interfacesProperties} workshopProductCombination={wsProdCombination}
                    productInterfaces={productInterfaces} workshopProduct={workshopProduct} />

            <WSTestCasesConfig product={product} workshopProduct={workshopProduct} interfaces={interfaces} productInterfaces={productInterfaces}
                testCombination={testCombinations ? testCombinations.find(tc => tc.id === wsProdCombination?.testCombinationId) : undefined}
                    wsProdCombination={wsProdCombination} workshopTestcases={workshopTestcases} testCases={testCases} wsTestCaseHandler={wsTestCaseHandler} /> 
            </>}
        {/*<Box>
            <Button startIcon={<VisibilityIcon />} onClick={() => setDisplayUnsupportedTestCases(!displayUnsupportedTestCases)}>{(displayUnsupportedTestCases) ? 'Show configuration' : 'Show test cases'}</Button>
        </Box>*/}
    </Stack>
}

export const WSTesting = ({ disableForms }: { disableForms?: boolean }) => {
    const { id } = useParams();
    const user = React.useContext(UserContext);
    const { showSnackbar } = useSnackbar();

    const [productList, setproductList] = React.useState<Product[]>([]);
    const [workshopProducts, setWorkshopProducts] = React.useState<WorkshopProduct[]>([]);
    const [interfaceList, setinterfaceList] = React.useState<Interface[]>([]);
    const [workshopInterfaces, setWorkshopInterfaces] = React.useState<WorkshopInterface[]>([]);
    const [validWorkshopInterfaces, setValidWorkshopInterfaces] = React.useState<WorkshopInterface[]>([]);
    const [wsProdCombinations, setWsProdCombinations] = React.useState<WorkshopProductCombination[]>([]);
    const [wsProdConfigCounters, setWsProdConfigCounters] = React.useState<WSProdConfigCounters[]>([]);
    const [wsProdCombination, setWsProdCombination] = React.useState<WorkshopProductCombination>(GetEmptyWSPTC());
    const [testCombinations, setTestCombinations] = React.useState<TestCombination[]>([]);
    const [selectedNode, setSelectedNode] = React.useState<string>('none');
    const [selectedTreeType, setSelectedTreeType] = React.useState<string>('none');
    const [selectedComboId, setSelectedComboId] = React.useState<string>('none');
    const [pageHeading, setPageHeading] = React.useState<string>('OPC Interoperability Test Page');
    const [productInterfaces, setProductInterfaces] = React.useState<Map<number, ProductInterface[]>>();
    const [interfacesProperties, setInterfacesProperties] = React.useState<InterfacesToProperties[]>([]);
    const [workshopTestcaseMap, setworkshopTestcaseMap] = React.useState<WorkshopTestCaseMap>();
    const [testCases, setTestCases] = React.useState<Map<number, TestCase[]>>();
    const [validWSInterfaces, setValidWSInterfaces] = React.useState<ProductInterface[]>([]);
    const [validTestCases, setValidTestCases] = React.useState<Map<number, TestCase[]>>(new Map<number, TestCase[]>());
    const [validInterfaceProps, setValidInterfaceProps] = React.useState<InterfacesToProperties[]>([]);
    const [currentWorkshopTestcases, setCurrentWorkshopTestcases] = React.useState<WorkshopTestCase[]>([]);
    const [isAdminUser, setIsAdminUser] = React.useState<boolean>(false);

    const showUserFeedback = React.useCallback((msg: string | null, severity: AlertProps['severity'] = 'error') => {
        msg && showSnackbar(msg, severity);
    }, [showSnackbar]);

    // after 60 secs of idle (or not recording new results) refresh the results
    React.useEffect(() => {
        console.log(`initializing user account check`);
        const interval = setInterval(() => {
            httpGet('/api/account/checkloginstatus', new AbortController());
        }, 60000);

        return () => {
            console.log(`clearing user account check Timer`);
            clearInterval(interval);
        };
    }, []);

    const wsTestCaseHandler = (wstc: WorkshopTestCase[]) => {
        let workshopTestcaseMapLoc = new Map(workshopTestcaseMap);
        workshopTestcaseMapLoc.set(wstc[0].workshopProductId, wstc);
        setworkshopTestcaseMap(workshopTestcaseMapLoc);
    }

    const refreshWorkshopProductHandler = async (wp: WorkshopProduct) => {
        if (wp.id.toString() !== selectedNode)
            return;

        if (wp.id === undefined || wp.id === 0) {
            return;
        }

        // get the updated workshop product
        const updatedWPResonse = await getSingleWorkshopProduct(wp.id, new AbortController());
        if (updatedWPResonse.failed) {
            showUserFeedback(updatedWPResonse.errorText);
            return;
        }

        // replace the updated workshop product in the workshopProducts array
        setWorkshopProducts(copyArrayWithIndexChanged(workshopProducts, workshopProducts.findIndex(wp => wp.id === updatedWPResonse.result.id), updatedWPResonse.result));

        const wptcResponse = await getWSProductTestcases(wp.id, new AbortController());
        if (wptcResponse.failed) {
            showUserFeedback(wptcResponse.errorText);
            return;
        }

        // find and replace the updated testcases in currentWorkshopTestcases
        let workshopTestcaseMapLoc = new Map(workshopTestcaseMap);
        let currentWorkshopTestcasesLoc = currentWorkshopTestcases;

        wptcResponse.result.forEach(response => {
            let workshopTestCase = currentWorkshopTestcasesLoc.find(wstc => wstc.id === response.id);
            if (!workshopTestCase) {
                currentWorkshopTestcasesLoc.push(response);
            }
            else {
                currentWorkshopTestcasesLoc = copyArrayWithIndexChanged(currentWorkshopTestcasesLoc, currentWorkshopTestcasesLoc.findIndex(wstc => wstc.id === response.id), response);
            }
        });

        workshopTestcaseMapLoc.set(wp.id, currentWorkshopTestcasesLoc);
        setworkshopTestcaseMap(workshopTestcaseMapLoc);

        // get the updated product interfaces
        const workshopProductInterfaces = await getWorkshopProductInterfaces(wp.id, new AbortController());
        if (workshopProductInterfaces.failed) {
            showUserFeedback(workshopProductInterfaces.errorText);
            return;
        }
        let productInterfacesLoc = new Map(productInterfaces);
        productInterfacesLoc.set(wp.id, workshopProductInterfaces.result);
        setProductInterfaces(productInterfacesLoc);
    }


    const workshopProductSubmitHandler = async (wp: WorkshopProduct, wptc: WorkshopProductCombination) => {
        const upResult = await updateWorkshopProduct(wp, new AbortController());
        if (upResult.failed) {
            showUserFeedback(upResult.errorText);
            return;
        }
        else {
            showUserFeedback("Product Information Saved Successfully.", 'success');
        }
        wp = upResult.result;

        const wptcResult = await updateProdTestCombination(wptc, new AbortController());
        if (wptcResult.failed) {
            showUserFeedback(wptcResult.errorText);
            return;
        }
        else {
            showUserFeedback("Product Information Saved Successfully.", 'success');
        }
        wptc = wptcResult.result;

        const newWorkshopProducts = copyArrayWithIndexChanged(workshopProducts, workshopProducts.findIndex(workshopProduct => wp.id === workshopProduct.id), wp);
        const newwsProdCombinations = copyArrayWithIndexChanged(wsProdCombinations, wsProdCombinations.findIndex(pc => wptc.id === pc.id), wptc);
        const product = productList.find(prod => prod.id === wp.productId)!;
        setPageHeading(composePageHeading(product, wp));
        setWorkshopProducts(newWorkshopProducts);
        setWsProdCombinations(newwsProdCombinations);
        setWsProdCombination(wptc);
    }

    const workshopProductComboRefreshHandler = async (wptc: WorkshopProductCombination, updatedCombinations: WorkshopProductCombination[]) => {
        let newwsProdCombinations = wsProdCombinations;

        updatedCombinations.forEach(updatedCombination => {
            if (wptc.id === updatedCombination.id) {
                setWsProdCombination(updatedCombination);
            }
            newwsProdCombinations = copyArrayWithIndexChanged(newwsProdCombinations ?? [], newwsProdCombinations?.findIndex(wpc => wpc.id === updatedCombination.id) ?? -1, updatedCombination);
        });

        setWsProdCombinations(newwsProdCombinations);
    }

    // inter faces
    const wpIfaceSubmitHandler = async (wpIfaces: ProductInterface[]) => {

        let wpIfacesLoc = productInterfaces?.get(Number(selectedNode)) ?? []

        let promiseResults: Promise<any>[] = [];
        wpIfaces.forEach((wpi, index) => {
            if (JSON.stringify(wpi) !== JSON.stringify(wpIfacesLoc[index])) {
                promiseResults.push(httpPost('/api/workshopproduct/interface/update', { ...wpi, serverEndpoint: wpi.serverEndpoint ?? "" }, new AbortController()));
            }
        });

        if (promiseResults.length === 0) return;
        const responses = await Promise.all(promiseResults);
        let someFailed = responses.find(response => response.failed);
        if (someFailed) {
            showUserFeedback(someFailed.errorText);
            return;
        }

        responses.forEach(response => {
            if (wpIfacesLoc) wpIfacesLoc = copyArrayWithIndexChanged(wpIfacesLoc, wpIfacesLoc.findIndex(i => i.interfaceId === response.result.interfaceId), response.result);
            else wpIfacesLoc = [response];
        });

        let productInterfacesLoc = new Map(productInterfaces);
        productInterfacesLoc.set(wpIfacesLoc[0].workshopProductId, wpIfacesLoc);
        setProductInterfaces(productInterfacesLoc);
        showUserFeedback("Product interface support updated.", "info");
    }
    
    React.useEffect(() => {
        const fetch = async () => {
            try {
                const sharedAbortController = new AbortController();
                let promiseResults: Promise<any>[] = [];

                let globalAdminFlag = await isGlobalAdmin(user.user.id!!, new AbortController());
                if (!globalAdminFlag) {
                    const workshopUsersResponse = await getWorkshopUsers(Number(id), new AbortController());
                    if (!workshopUsersResponse.failed) {
                        globalAdminFlag = workshopUsersResponse.result.find(wu => wu.userId === user.user.id)?.isWorkshopAdmin ?? false;
                    }
                }
                setIsAdminUser(globalAdminFlag);

                const companiesResponse = getCompanyWpID(user.user.companyId!!, sharedAbortController);
                promiseResults.push(companiesResponse);
                const productsResponse = getProducts(sharedAbortController);
                promiseResults.push(productsResponse);
                const workshopProductsResponse = getWorkshopProducts(Number(id), sharedAbortController);
                promiseResults.push(workshopProductsResponse);
                const interfacesResponse = enumerateInterfaces(sharedAbortController);
                promiseResults.push(interfacesResponse);
                const workshopInterfacesResponse = getWorkshopInterfaces(Number(id), sharedAbortController);
                promiseResults.push(workshopInterfacesResponse);
                const wsProdCombinationsResponse = getWSProductCombinations(Number(id), sharedAbortController);
                promiseResults.push(wsProdCombinationsResponse);
                const testCombinationsResponse = getTestCombinationList(sharedAbortController);
                promiseResults.push(testCombinationsResponse);
                const wsProdConfigCountersResponse = getWSProdConfigCounters(Number(id) , sharedAbortController);
                promiseResults.push(wsProdConfigCountersResponse);

                const responses = await Promise.all(promiseResults);

                let someFailed = responses.find(response => response.failed);
                const filterDisabled = globalAdminFlag;

                if (someFailed) {
                    showUserFeedback(someFailed.errorText);
                    return;
                }

                const userCompany = (await companiesResponse).result;
                const allProducts = (await productsResponse).result;
                const UserProducts = filterDisabled ? allProducts : allProducts.filter(product => product.companyId === userCompany?.id);
                setproductList(UserProducts);

                const allWorkshopProducts = (await workshopProductsResponse).result;
                const UserWorkshopProducts = filterDisabled ? allWorkshopProducts : allWorkshopProducts.filter(wp => UserProducts.find(prod => prod.id === wp.productId));
                setWorkshopProducts(UserWorkshopProducts);

                let wsProdCombinationsLoc = (await wsProdCombinationsResponse).result;
                wsProdCombinationsLoc = wsProdCombinationsLoc.filter(wpc => wpc.isConsumer || wpc.isProvider);
                wsProdCombinationsLoc = filterDisabled ? wsProdCombinationsLoc : wsProdCombinationsLoc.filter(wpc => UserWorkshopProducts.find(wp => wp.id === wpc.workshopProductId));
                setWsProdCombinations(wsProdCombinationsLoc);

                let wsProdConfigCountersLoc = (await wsProdConfigCountersResponse).result;
                wsProdConfigCountersLoc = wsProdConfigCountersLoc.filter(wpcc => wsProdCombinationsLoc.find(wpc => wpc.id === wpcc.workshopProductCombinationId));
                setWsProdConfigCounters(wsProdConfigCountersLoc);

                const interfaceListLoc = (await interfacesResponse).result;
                setinterfaceList(interfaceListLoc);

                const workshopInterfacesLoc = (await workshopInterfacesResponse).result;
                setWorkshopInterfaces(workshopInterfacesLoc);

                const testCombinationsLoc = (await testCombinationsResponse).result;
                setTestCombinations(testCombinationsLoc);

                const testCaseResponses = await Promise.all(workshopInterfacesLoc.map(iface => getTestCases(iface.interfaceId, new AbortController())));
                someFailed = testCaseResponses.find(response => response.failed);

                if (someFailed) {
                    console.log('FailedResponse: ', someFailed);
                    showUserFeedback(someFailed.errorText);
                    return;
                }
                // convert workshopProductInterfaceResponse into a ProductInterfaceMap
                const TestcasesLoc: Map<number, TestCase[]> = new Map();
                testCaseResponses.forEach(response => {
                    if(response.result[0]) TestcasesLoc.set(response.result[0]?.interfaceId, response.result);
                });
                setTestCases(TestcasesLoc);

                const workshopProductInterfaceResponse = await Promise.all(UserWorkshopProducts.map(wsProd => getWorkshopProductInterfaces(wsProd.id, new AbortController())));
                someFailed = workshopProductInterfaceResponse.find(response => response.failed);

                if (someFailed) {
                    console.log('FailedResponse: ', someFailed);
                    showUserFeedback(someFailed.errorText);
                    return;
                }
                // convert workshopProductInterfaceResponse into a ProductInterfaceMap
                const productInterfacesLoc: Map<number, ProductInterface[]> = new Map();
                workshopProductInterfaceResponse.forEach(response => {
                    if(response.result[0]) productInterfacesLoc.set(response.result[0]?.workshopProductId, response.result);
                });
                setProductInterfaces(productInterfacesLoc);

                const wsTestCaseResponses = await Promise.all(UserWorkshopProducts.map(wsProd => getWSProductTestcases(wsProd.id, new AbortController())));
                someFailed = wsTestCaseResponses.find(response => response.failed);

                if (someFailed) {
                    console.log('FailedResponse: ', someFailed);
                    showUserFeedback(someFailed.errorText);
                    return;
                }
                // convert wsTestCaseResponses into a WorkshopTestCaseMap
                const workshopTestcaseMapLoc: WorkshopTestCaseMap = new Map();
                wsTestCaseResponses.forEach(response => {
                    if (response.result[0]) workshopTestcaseMapLoc.set(response.result[0]?.workshopProductId, response.result);
                });
                setworkshopTestcaseMap(workshopTestcaseMapLoc);

            } catch (error) {
                showUserFeedback(String(error));
            }
        }

        fetch();
    }, [id, user, showUserFeedback]);

    React.useEffect(() => {
        let interfacesToProperties: InterfacesToProperties[] = [];

        for (let iface of interfaceList) {
            httpGet(`/api/interface/property/${iface.id}`, new AbortController())
                .then((answer) => { interfacesToProperties.push({ iface, properties: answer.result }); });
        }

        setInterfacesProperties(interfacesToProperties);
    }, [interfaceList]);

    React.useEffect(() => {
        const fetch = async () => {
            if (wsProdCombination.testCombinationId === 0) {
                setValidWSInterfaces([]);
                setValidInterfaceProps([]);
                setCurrentWorkshopTestcases([]);
                setValidTestCases(new Map<number, TestCase[]>());
                return; // no test combination selected
            }
            let testSupportSearch: TestComboSupportVal = { testCombinationId: wsProdCombination.testCombinationId }
            const testComboSupportedResponse = await getTestComboSupport(testSupportSearch, new AbortController());

            if (testComboSupportedResponse.failed) {
                showUserFeedback(testComboSupportedResponse.errorText);
                return;
            }
            const testComboSupported = testComboSupportedResponse.result;
            let validWSInterfacesLoc: ProductInterface[] = [];
            let validInterfacesLoc: WorkshopInterface[] = [];
            let productInterfacesLoc: ProductInterface[] = productInterfaces?.get(wsProdCombination.workshopProductId) ?? [];
            let currentIfaceProps: InterfacesToProperties;
            let validInterfacePropsLoc: InterfacesToProperties[] = [];
            let interfacesPropertiesLoc: InterfacesToProperties[] = interfacesProperties.filter(ip => productInterfaces?.get(wsProdCombination.workshopProductId)?.some(pi => pi.interfaceId === ip.iface.id)) ?? [];
            let workshopTestcases: WorkshopTestCase[] = workshopTestcaseMap?.get(wsProdCombination.workshopProductId) ?? [];
            let currentWorkshopTestcasesLoc: WorkshopTestCase[] = [];
            let validTestCasesLoc: Map<number, TestCase[]> = new Map<number, TestCase[]>();

            if (testCases) {
                testCases.forEach((tcList, ifaceId) => {
                    if (!validTestCasesLoc.has(ifaceId)) {
                        validTestCasesLoc.set(ifaceId, []);
                    }
                    tcList.forEach(tc => {
                        if (testComboSupported.find(tcs => tcs.interfaceId === ifaceId && tcs.testCaseId === tc.id)) {
                            validTestCasesLoc.get(ifaceId)?.push(tc);
                        }
                    });
                });
            };

            productInterfacesLoc.forEach(pi => {
                if (testComboSupported.find(tcs => tcs.interfaceId === pi.interfaceId && tcs.testCaseId === 0 && tcs.interfacePropertyId === 0)) {
                    validWSInterfacesLoc.push(pi);
                }
            });

            workshopInterfaces.forEach(wi => {
                if (testComboSupported.find(tcs => tcs.interfaceId === wi.interfaceId && tcs.testCaseId === 0 && tcs.interfacePropertyId === 0)) {  // only add workshop interfaces for interfaces that are valid for the current test combination
                    validInterfacesLoc.push(wi);
                }
            });
            setValidWorkshopInterfaces(validInterfacesLoc);

            interfacesPropertiesLoc.forEach(ip => {
                if (validWSInterfacesLoc.find(pi => pi.interfaceId === ip.iface.id)) {  // only add properties for interfaces that are valid for the current test combination
                    currentIfaceProps = { iface: ip.iface, properties: [] };
                    ip.properties.forEach(prop => {
                        if (testComboSupported.find(tcs => tcs.interfaceId === prop.interfaceId && tcs.testCaseId === 0 && tcs.interfacePropertyId === prop.id)) {
                            currentIfaceProps.properties.push(prop);
                        }
                    });
                    validInterfacePropsLoc.push(currentIfaceProps);
                }
            });

            workshopTestcases.forEach(wstc => {
                if (testComboSupported.find(tcs => tcs.testCombinationId === wstc.testCombinationId && tcs.testCaseId === wstc.testCaseId)) {
                    currentWorkshopTestcasesLoc.push(wstc);
                }
            });

            setValidWSInterfaces(validWSInterfacesLoc);
            setValidInterfaceProps(validInterfacePropsLoc);
            setCurrentWorkshopTestcases(currentWorkshopTestcasesLoc);
            setValidTestCases(validTestCasesLoc);
        }
        fetch();
    }, [wsProdCombination, testCases, interfacesProperties, workshopInterfaces, productInterfaces, workshopTestcaseMap, showUserFeedback]);

    const handleNodeSelect = (event: React.SyntheticEvent, nodeIds: string) => {
        let tComboId: string, tComboType: string, wsProdId: string;
        // nodeIds is in the format "treeType-nodeId", unless it is "Client" or "Server" or "none"
        [tComboId, tComboType, wsProdId] = nodeIds.split('-');

        if (wsProdId === undefined || (wsProdId === selectedNode && tComboType === selectedTreeType && tComboId === selectedComboId)) {
            const heading = "OPC Interoperability Test Page"
            setSelectedNode('none');
            setSelectedTreeType('none');
            setSelectedComboId('none');
            setPageHeading(heading);
        }
        else {
            let workshopProduct = workshopProducts.find(ws => ws.id.toString() === wsProdId)!;
            let product = productList.find(product => product.id === workshopProduct?.productId)!;
            let pageHeading = composePageHeading(product, workshopProduct);
            let wsProdCombinationLoc = wsProdCombinations.find(wspc => wspc.workshopProductId.toString() === wsProdId && wspc.testCombinationId.toString() === tComboId) ?? GetEmptyWSPTC();

            console.log('nodeIds: ', nodeIds);

            setWsProdCombination(wsProdCombinationLoc);
            setSelectedNode(wsProdId);
            setSelectedTreeType(tComboType);
            setSelectedComboId(tComboId);
            setPageHeading(pageHeading);
        }
    }

    const breadcrumbs: BreadCrumbProps[] = [
        { to: "/TestingTab", text: "Workshop Selection" },
        { to: `/wstestingconfig/${id}`, text: "Configure" },
        { to: `/wstestingrecords/${id}`, text: "Start Testing" },
    ];
    
    return <PageAlternate sidePanel={<ProductTreeView products={productList} workshopProducts={workshopProducts}
        wsProdCombinations={wsProdCombinations} testCombinations={testCombinations}
        wsProdConfigCounters={wsProdConfigCounters} getSelectedNode={() => selectedNode} nodeSelectHandler={handleNodeSelect} />}
        backButton heading={<Typography color={'info'} variant="h4">{isAdminUser ? pageHeading + ' - Admin View' : pageHeading}</Typography>}
        breadcrumbs={breadcrumbs}>
            {[((wsProdCombination?.isProvider && selectedTreeType === 'P') ?

                <ServerScreen selectedTreeType={selectedTreeType}
                    isGlobalAdminUser={isAdminUser}
                    testCombinations={testCombinations}
                    wsProdCombinations={wsProdCombinations}
                    wsProdCombination={wsProdCombination}
                    workshopProduct={workshopProducts.find(ws => ws.id.toString() === selectedNode) as WorkshopProduct}
                    product={productList.find(pd => workshopProducts.find(wsp => wsp.id.toString() === selectedNode)?.productId.toString() === pd.id.toString()) as Product}
                    productInterfaces={validWSInterfaces} interfaces={interfaceList}
                    interfacesProperties={validInterfaceProps}
                    workshopInterfaces={validWorkshopInterfaces}
                    workshopTestcases={currentWorkshopTestcases}
                    testCases={validTestCases}
                    wsTestCaseHandler={wsTestCaseHandler}
                    disabled={false}
                    wpSubmitHandler={workshopProductSubmitHandler}
                    wptcUpdateHandler={workshopProductComboRefreshHandler}
                    refreshWorkshopProductHandler={refreshWorkshopProductHandler}
                    wpIfaceSubmitHandler={wpIfaceSubmitHandler} />
                : (wsProdCombination?.isConsumer && selectedTreeType === 'C') ?
                <ClientScreen selectedTreeType={selectedTreeType} workshopProduct={workshopProducts.find(ws => ws.id.toString() === selectedNode) as WorkshopProduct}
                    wsProdCombination={wsProdCombination} 
                    testCombinations={testCombinations}
                    wsProdCombinations={wsProdCombinations}
                    isGlobalAdminUser={isAdminUser}
                    product={productList.find(pd => workshopProducts.find(wsp => wsp.id.toString() === selectedNode)?.productId.toString() === pd.id.toString()) as Product}
                    productInterfaces={validWSInterfaces} interfaces={interfaceList}
                    workshopInterfaces={validWorkshopInterfaces}
                    workshopTestcases={currentWorkshopTestcases}
                    testCases={validTestCases}
                    wsTestCaseHandler={wsTestCaseHandler}
                    wpSubmitHandler={workshopProductSubmitHandler}
                    wptcUpdateHandler={workshopProductComboRefreshHandler}
                    refreshWorkshopProductHandler={refreshWorkshopProductHandler}
                    wpIfaceSubmitHandler={wpIfaceSubmitHandler} />
                : <TestingInfo />
            )]}
    </PageAlternate>
}